/**
 * Alert <uo-accordion-item-li>
 *
 * Attributes:
 */

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
const styles = require( './web-component-style.scss' );

@customElement( 'uo-accordion-item-li' )
export class AutomatorAccordionItemLi extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	constructor() {
		super();
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="item">
				<div class="item-content">
					<slot></slot>
				</div>
				<div class="item-chip">
					<slot name="chip"></slot>
				</div>
			</div>
		`;
	}
}
